import { useStoreApi } from '@xyflow/react';
import { tryit } from 'radash';
import * as API from '../services';
import { useWorkflowStore } from '../store';
import { Edge, Node } from '../types';
import { useNodeDataUpdate } from './use-node-data-update';
import { useWorkflowReadOnly } from './use-workflow';
/**
 * 保存节点表单 hook
 */
export const useNodeSyncForm = () => {
  const workflowStore = useWorkflowStore();
  const store = useStoreApi<Node, Edge>();
  const { getNodesReadOnly } = useWorkflowReadOnly();
  const { handleNodeDataUpdate } = useNodeDataUpdate();

  const doSyncNodeFormDraft = async ({
    nodeId,
    jobData,
  }: {
    nodeId: string;
    jobData: Node['data']['_form'];
  }) => {
    if (getNodesReadOnly()) return;
    const { template_code } = workflowStore.getState();
    workflowStore.setState({ isSyncingWorkflowDraft: true });

    const [error, data] = await tryit(API.saveNodeJobData)({
      node_uid: nodeId,
      template_code: template_code,
      body: jobData,
    });

    if (error) return;

    const valid = data?.data?.valid;
    const tags = data?.data?.canvas_node_tags;

    handleNodeDataUpdate({
      id: nodeId,
      data: { valid, tags },
    });

    workflowStore.setState({ isSyncingWorkflowDraft: false });
  };

  return {
    doSyncNodeFormDraft,
  };
};
